<template>
  <div
    class="nx-text-body3 tw-border tw-border-solid tw-rounded-full tw-inline-block tw-px-2 tw-py-1"
    :class="[pillType]"
  >
    <slot>{{ content }}</slot>
  </div>
</template>

<script>
import { computed } from "vue";

export default {
  name: "Pill",
  props: {
    variant: {
      type: String,
      default: "primary",
      validator: (val) => ["primary", "highlight", "success", "danger", "warning"].includes(val),
    },
    content: {
      type: String,
      default: null,
    },
  },
  setup(props) {
    const typeList = {
      primary: "tw-text-text tw-border-text",
      highlight: "tw-text-highlight-text-medium tw-border-highlight-border",
      success: "tw-text-success-border tw-border-success-border",
      danger: "tw-text-danger-text-medium tw-border-danger-text-medium",
      warning: "tw-text-warning-text-medium tw-border-warning-text-medium",
    };
    const pillType = computed(() => typeList[props.variant] || typeList.primary);
    return {
      pillType,
    };
  },
};
</script>
